import type ChangeStatus from '@/enum/ChangeStatus'
import type { IBase } from '@/interfaces/base/IBase'

class Base implements IBase {
  id: string

  changeStatus?: ChangeStatus

  constructor(entity: any) {
    this.id = entity?.id
    this.changeStatus = entity?.changeStatus
  }
}

export default Base
